// extracted by mini-css-extract-plugin
module.exports =  {"common":"HeaderTitle-module__common___m6IcU","month":"HeaderTitle-module__month___tvGwn"};